import { BrowserCacheLocation, Configuration } from '@azure/msal-browser';
import { environment } from '../../environments/environment';

export const loginRequest = {
    scopes: [],
};

export const b2cPolicies = {
    names: {
        signUpSignIn: 'B2C_1_rapidGyanSignIn',
        resetPassword: 'B2C_1_rapidGyanResetPassword',
        editProfile: 'B2C_1_gyanEditProfile',
    },
    authorities: {
        signUpSignIn: {
            authority: environment.azureAdB2CPolSignUpSignIn,
        },
        resetPassword: {
            authority: environment.azureAdB2CPolResetPassword,
        },
        editProfile: {
            authority: environment.azureAdB2CPolEditProfile,
        },
    },
    authorityDomain: environment.azureAdB2CPolAuthorityDomain,
};

export const msalConfig: Configuration = {
    auth: {
        clientId: environment.azureAdB2CAuthClientId,
        authority: b2cPolicies.authorities.signUpSignIn.authority, // Defaults to "https://login.microsoftonline.com/common"
        knownAuthorities: [b2cPolicies.authorityDomain, 'graph.microsoft.com'], // Mark your B2C tenant's domain as trusted.
        redirectUri: environment.appUrl,
        // redirectUri: '/#/auth-token/', // Points to window.location.origin by default. You must register this URI on Azure portal/App Registration.
        // postLogoutRedirectUri: '/',
        // postLogoutRedirectUri: '/signup', // Points to window.location.origin by default.
    },
    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        //        storeAuthStateInCookie: isIE, // set to true for IE 11
    },
};

export const protectedResources = new Map([['https://graph.microsoft.com/v1.0/me', ['user.read']]]);
